import {useEffect, useRef} from 'react';

/**
 * @param containerRef
 * @param onSwipeDown
 * @returns {{ onTouchStart: function, onTouchMove: function, onTouchEnd: function }}
 */
export default function useSwipeDownCloseModal({currentPage, onSwipeDown = () => {}}) {
  const swiper = useRef(null);
  useEffect(() => {
    const widget = document.querySelector('.Avada-Faqs_Popup:not(.admin)');

    let timeResize = null;

    if (!swiper || !widget || !swiper.current) return;
    const heightWidget = widget.offsetHeight;
    const swiperComponent = swiper.current;
    swiperComponent.style.setHeight = '64px';
    swiperComponent.addEventListener('touchstart', handleTouchStart, false);
    swiperComponent.addEventListener('touchmove', handleTouchMove, false);
    swiperComponent.addEventListener('touchend', handleTouchEnd, false);

    let yDown = null;
    function getTouches(evt) {
      return evt.touches || evt.originalEvent.touches;
    }
    function handleTouchEnd(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      clearTimeout(timeResize);
      timeResize = setTimeout(() => {
        const isClosed = widget.style.maxHeight === '0px';
        if (!isClosed) {
          widget.style.maxHeight = '100%';
        }
      }, 100);
    }
    function handleTouchStart(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      const firstTouch = getTouches(evt)[0];
      if (firstTouch.clientY) {
        yDown = firstTouch.clientY;
      }
    }
    function handleTouchMove(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!yDown) {
        return;
      }
      const yUp = evt.touches[0].clientY;
      const yDiff = yDown - yUp;

      if (yDiff < -300) {
        widget.style.maxHeight = '0px';
        setTimeout(() => {
          widget.style.display = 'none';
          onSwipeDown();
          setTimeout(() => {
            widget.style.display = 'block';
          }, 10);
          widget.style.maxHeight = heightWidget + 'px';
        }, 10);
        return;
      }
      widget.style.maxHeight = heightWidget - Math.abs(yDiff) + 'px';
    }
    return () => {
      swiperComponent.removeEventListener('touchstart', handleTouchStart);
      swiperComponent.removeEventListener('touchmove', handleTouchMove);
    };
  }, [currentPage, swiper.current]);
  return {swiper};
}
